/*
  LOOSH – Bildergalerie pro Sorte
  ---------------------------------------------------------------
  Das Theme tauscht beim Sortenwechsel nur Preis, SKU, Bestand,
  Buttons und Cart Bar aus – die Bildergalerie bleibt stehen.
  Dieses Skript hoert auf das theme-eigene "variantChange"-Event,
  nimmt die schon fertig geladene neue Sektion und ersetzt damit
  das <product-images>-Element. Da es ein Custom Element ist,
  initialisiert sich der Slider dabei von selbst neu.
*/
(function () {
  'use strict';

  function findGallery(sectionId) {
    var scope =
      document.querySelector('product-info[data-section="' + sectionId + '"]') ||
      document.querySelector('product-info[data-section-id="' + sectionId + '"]') ||
      document.querySelector('product-info');

    return scope ? scope.querySelector('product-images') : null;
  }

  function swapGallery(event) {
    var data = event && event.data ? event.data : null;
    if (!data || !data.html || !data.sectionId) return;

    var current = findGallery(data.sectionId);
    if (!current) return;

    var next = data.html.querySelector('product-images');
    if (!next) return;

    // Nichts tun, wenn sich die Bilder gar nicht geaendert haben.
    if (next.innerHTML.trim() === current.innerHTML.trim()) return;

    current.replaceWith(next.cloneNode(true));
  }

  function init() {
    if (typeof window.subscribe !== 'function') return;
    if (!window.theme || !window.theme.PUB_SUB_EVENTS) return;
    if (!window.theme.PUB_SUB_EVENTS.variantChange) return;

    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, swapGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();